<!--首页-->
<template>
  <div class="loginBody" v-bind:style="loginHeight" :style="getLoginBg">
    <!--定位-->
    <div class="content"></div>
    <PositioningAddress></PositioningAddress>
    <div class="videoBg" v-if="loginVideoUrl != undefined && loginVideoUrl.length > 0">
      <!-- 如果添不加 muted 静音，有时候不能自动播放，是chrome的限制 -->
      <video autoplay="true" loop="true" muted class="videoPlayer">
        <source :src="loginVideoUrl" type="audio/mp4" />
        您的浏览器不支持 Video 标签
      </video>
    </div>
    <div class="unitTitle">
      <div style=" display: flex;  justify-content: center;font-weight: bold;">
        <!--客户特殊需求：登陆页 展示logo和字体变更-->
        <img v-show="logImg != ''" :src="logImg" class="logo" alt="" />
        <p class="cnTitle" v-if="companyTitle != ''" :style="{ 'font-size':36 + 'px', 'line-height': 40 + 'px' }"
          style="font-family: 宋体">
          {{ companyTitle }}
        </p>

        <!--常规登陆页-->
        <p class="cnTitle" v-else :style="{ 
            'font-size': 48 - index * 4 + 'px',
            'line-height': 48 - index * 4 + 'px',
          }" v-for="(item, index) in titles">
          {{ item }}
        </p>
      </div>
      <div class="qrcodediv" v-show="qrCodeShow">
        <!-- 底部app扫码用的二维码，每个单位可能不一样 -->
        <div class="qrcode">
          <div id="urlCode" style="width: 100px; height: 100px"></div>
          <p>{{ qrCodeList.name }}</p>
        </div>
        <!--<div class="qrcode">
					<div id="javaCode" style="width: 100px;height: 100px;"></div>
					<p>APP后台连接</p>
				</div>-->
      </div>
    </div>

    <div v-show="copyRightIsDisplay" class="information flexCenterColumn">
      <a :href="copyRightUrl" target="_Blank">{{ copyRight.rightinfo }}</a>
      <a :href="copyRightUrl" target="_Blank">{{ copyRight.rightNumber }}</a>
    </div>
    <div class="loginContent">
      <p class="loginTitle">用户登录</p>
      <p class="loginTitle loginTitle_txt">
        - USER&nbsp;&nbsp;&nbsp;&nbsp;LOGIN -
      </p>
      <div class="loginText flexStart" v-show="!showChangPW">
        <img src="/static/unitInformation/user.png" />
        <el-input class="inputed" v-model="userCode" placeholder="用户名" @keyup.enter="loginButton" autofocus
          @blur="checkUser"></el-input>
      </div>
      <div class="loginText flexStart" v-show="!showChangPW">
        <img src="/static/unitInformation/password.png" slot="prepend" />
        <el-input class="inputed" placeholder="密码" v-model="password" show-password
          @keyup.enter.native="loginButton"></el-input>

      </div>

      <div class="loginText flexStart" v-show="verificationCode && !showChangPW && userCode && password">
        <img src="/static/unitInformation/code.png" /><input type="text" v-model="seccode" placeholder="验证码"
          @keyup.enter="loginButton" style="width: 150px" />
        <img v-if="DWSystemSetting"
          :src="DWSystemSetting.baseURL+'/verification/code/qet?userCode='+userCode+'&i='+index"
          style=" width: 100%; height:36px; " @click="index++">
      </div>
      <!-- <div class="loginText flexStart" v-show="verificationCode && !showChangPW">
        <img :src="getResourcesByName('login/code.png')" /><input type="text" v-model="seccode" placeholder="验证码"
          @keyup.enter="loginButton" style="width: 150px" />
        <valid-code ref="validCode"></valid-code>
      </div> -->
      <!-- 修改密码-->
      <div class="loginText flexStart" v-show="showChangPW">
        <img :src="getResourcesByName('login/password.png')" /><input type="password" name="newPassword"
          v-model="newPassword" placeholder="输入新密码" @blur.prevent="regPW" />
      </div>
      <div class="loginText flexStart" v-show="showChangPW">
        <img :src="getResourcesByName('login/password.png')" /><input type="password" name="checkPassword"
          v-model="checkPassword" placeholder="确认新密码" />
      </div>
      <span id="loginSpan" class="loginButton nomalButton" @click="loginButton" v-show="!showChangPW">登 录</span>
      <span class="loginButton nomalButton" @click="submitButton" v-show="showChangPW">提交修改</span>
      <span class="errorMsg" v-if="errorMsg != ''"><img :src="getResourcesByName('login/error.png')" />&nbsp;&nbsp;{{
        errorMsg
        }}</span>
    </div>
  </div>
</template>

<script type="text/javascript">
  import PositioningAddress from "@/components/module/map/PositioningAddress.vue";
  import validCode from "@/components/module/code/validCode.vue";
  import {getReadDeviceTree} from "../api/abbNewApi";
  import request from "@/api/http.js";
  export default {
    components: {
      validCode,
      PositioningAddress,
    },
    props: [],
    data () {
      return {
        DWSystemSetting: '',
        index: 1,
        image: '',
        showChangPW: false,
        userCode: "",
        password: "",
        newPassword: "",
        checkPassword: "",
        seccode: "",
        codelist: "",
        errorMsg: "",
        copyRightIsDisplay: true, //是否展示copyright
        qrCodeList: {
          name: "",
          url: "",
        },
        logImg: "",
        companyTitle: "", //TITLE
        loginVideoUrl: undefined,
        loginImgBgUrl: undefined,
        copyRight: {
          rightinfo: "",
          rightNumber: "",
        },
        copyRightUrl: undefined,
        verificationCode: false, //配置验证码显示隐藏
        qrCodeShow: false,
        isStrongPassword: 0,
        mybaseURL: ""
      };
    },
    created () {
      debugPage=this;
      //初始化配置
      this.$store.menuStore.state.menuType=1;
      this.mybaseURL=localStorage.getItem("baseURL")
      if(
        DWSystemSetting!=undefined&&
        DWSystemSetting.verificationCode!=undefined
      ) {
        this.verificationCode=DWSystemSetting.verificationCode;
        this.qrCodeShow=DWSystemSetting.qrCodeShow;
      }

      if(
        DWSystemSetting.logDingZhi!=undefined&&
        DWSystemSetting.companyName!=undefined&&
        !isempty(DWSystemSetting.logDingZhi[DWSystemSetting.companyName])
      ) {
        //debugger
        if(!isempty(DWSystemSetting.logDingZhi[DWSystemSetting.companyName])) {
          this.logImg=DWSystemSetting.logDingZhi[DWSystemSetting.companyName];
        }
      } else {
        this.logImg="";
      }

      if(DWSystemSetting.companyTitle!=undefined) {
        this.companyTitle=DWSystemSetting.companyTitle;
      } else {
        this.companyTitle="";
      }

      if(DWSystemSetting.copyRightIsDisplay!=undefined) {
        this.copyRightIsDisplay=DWSystemSetting.copyRightIsDisplay;
      } else {
        this.copyRightIsDisplay=true;
      }
      //是否需要强验证
      if(DWSystemSetting.isStrongPassword!=undefined) {
        this.isStrongPassword=DWSystemSetting.isStrongPassword;
      }
    },
    mounted () {
      // console.log("登录",this.$route.query.userCode);
      var num=0;
      // http://10.50.0.134:8080/#/?userCode=admin&password=admin
      var d=setInterval((v) => {
        this.userCode=this.getQueryVariable("userCode");
        // this.password = this.getQueryVariable("userCode");
        num++;
        if(this.userCode||num>2) {
          clearInterval(d);
        }
        if(this.userCode) {
          this.userCode=this.getQueryVariable("userCode")||"";
          this.password=this.getQueryVariable("userCode")||"";
          // this.password = 3
          this.loginButton();
        }
      },900);
      request({url: "/basicConfig/findorupdate",method: "post"}).then(res => {
        if(res.code==200) {
          this.loginImgBgUrl="/static/unitInformation/loginBg"+res.data.backgroundCode+".png";
          this.verificationCode=res.data.verificationState=="ENABLE"? true:false;
        }
      })
      // this.code();
      //设置二维码列表
      this.qrCodeList=DWSystemSetting.qrCodeList;
      //为二维码增加参数·避免缓存
      for(var i=0,len=this.qrCodeList.length;i<len;i++) {
        var item=this.qrCodeList[i];
        item.url=item.url+"?version="+new Date().formatByDate();
      }
      //设置视频背景
      this.loginVideoUrl=DWSystemSetting.loginVideoUrl;
      //设置图片背景
      this.loginImgBgUrl="/static/unitInformation/loginBg.png";
      if(!isempty(this.loginImgBgUrl)) {
        //每天刷新缓存
        this.loginImgBgUrl=
          this.loginImgBgUrl+"?version="+new Date().formatByDate();
      }
      //设置版权声明
      this.copyRight=DWSystemSetting.copyRight;
      this.copyRightUrl=DWSystemSetting.copyRightUrl;
      //后台连接的二维码
      var qrcode=new QRCode(document.getElementById("urlCode"),{
        width: 90,
        height: 90,
      });
      qrcode.makeCode(DWSystemSetting.qrCodeList.url);
      /*下载的二维码*/
      /*new QRCode(document.getElementById("urlCode"),{width: 100,height: 100}).makeCode(DWSystemSetting.qrCodeList.url)*/
    },
    destroyed () {},
    computed: {
      titles () {
        if(this.webConfig==undefined||this.webConfig.Title==undefined) {
          return [""];
        }
        var list=this.webConfig.Title.split(";");
        document.title=list[0];
        return list;
      },
      loginHeight () {
        return {
          height: ""+this.height/100+"rem",
        };
      },
      webConfig () {
        return this.$store.cacheStore.getters.getWebConfig;
      },
      skinFlag () {
        return this.$store.cacheStore.state.skinFlag;
      },

      getBackgroudImageStyle () {
        return this.$store.resourcesStore.getters.getBackgroudImageStyle;
      },
      getColorStyleById () {
        return this.$store.resourcesStore.getters.getColorStyleById;
      },
      getResourcesByName () {
        return this.$store.resourcesStore.getters.getResourcesByName;
      },
      getClassName () {
        return this.$store.resourcesStore.getters.getClassName;
      },
      getLoginBg () {
        return !isempty(this.loginVideoUrl)
          ? {}
          :{
            "background-image": "url("+this.loginImgBgUrl+")",
            "background-size": "100% 100%",
            "background-repeat": "no-repeat",
            "height": "100% !important",
          };
      },
    },
    watch: {
      userCode (nv,ov) {
        this.errorMsg="";
      },
      password (nv,ov) {
        this.errorMsg="";
      },
    },
    methods: {

      getQueryVariable (variable) {
        if(window.location.href.indexOf("?")==-1) {
          $(".loginBody").css("opacity",1);
          return;
        }
        var query=window.location.href.split("?")[1];

        var vars=query.split("&");
        for(var i=0;i<vars.length;i++) {
          var pair=vars[i].split("=");
          if(pair[0]==variable) {
            return pair[1];
          }
        }
        return false;
      },
      checkUser () {
        if(this.isStrongPassword==0) {
          return;
        }
        this.$api.userApi.checkUser(
          this.userCode,
          (respon) => {
            $("#loginSpan").css("pointer-events","auto");
            $("#loginSpan").css("background","#308ff7");
          },
          (respon) => {
            this.$dialogMethod.showMessage(respon);
            $("#loginSpan").css("background","#ccc");
            $("#loginSpan").css("pointer-events","none");
          }
        );
      },
      submitButton () {
        this.regPW();
        if(this.newPassword==this.checkPassword) {
          //修改后端数据
          this.$api.userApi.changePW(
            this.userCode,
            hex_md5(this.password),
            hex_md5(this.newPassword),
            "Web",
            (respon) => {
              this.$dialogMethod.showMessage("修改成功！");
              //获取用户信息
              localStorage.setItem("nowWedoSystemUserCode",this.userCode);
              this.$store.userStore.commit("setNowUserCode",this.userCode);
              //用户的具体信息
              localStorage.setItem("userDetailed",JSON.stringify(respon));
              //获取用户单位信息
              this.$store.unitStore.commit("getUnitTree");



              //this.$dialogMethod.showMessage("登录成功，正在跳转。。。");
              setTimeout(() => {
                //获取菜单并且进入主界面
                this.$store.menuStore.commit("getMenuList");
                this.$store.deviceStore.commit(
                  "getReadDeviceTreeWithTypeNos",
                  36
                );

              },1000);
              sessionStorage.setItem("isLogin",Date.now());
              //连接新后台
              this.$wedoWebSocketClient.connect(respon.webSocketUrl,respon.pkid);
            },
            (respon) => {
              this.$dialogMethod.showMessage(respon);
            }
          );
        } else {
          this.$dialogMethod.showMessage("输入密码不一致！");
        }
      },
      regPW () {
        if(this.newPassword.length<8||this.newPassword.length>16) {
          this.$dialogMethod.showMessage("密码长度不符合，密码长度：8-16！");
          return;
        }
        var rgx=/^[0-9a-zA-Z\x21-\x7e]{8,16}$/;
        if(!rgx.test(this.newPassword)) {
          this.$dialogMethod.showMessage("密码只能包含数字，字母和字符！");
          return;
        }
        var iNum=0,
          iLtt=0,
          iSym=0;
        var num=this.newPassword.match(/\d{1}/g);

        if(num!=null) {
          for(let i=0;i<num.length;i++) {
            iNum++;
          }
        }

        var ltt=this.newPassword.match(/[a-zA-Z]/g);

        if(ltt!=null) {
          for(let i=0;i<ltt.length;i++) {
            iLtt++;
          }
        }

        var sym=this.newPassword.match(/((?=[\x21-\x7e]+)[^A-Za-z0-9])/g);

        if(sym!=null) {
          for(let i=0;i<sym.length;i++) {
            iSym++;
          }
        }

        if(iLtt==0&&iSym==0) {
          this.$dialogMethod.showMessage("纯数字密码，请加入字符和字母！");
          return;
        }
        if(iNum==0&&iLtt==0) {
          this.$dialogMethod.showMessage("纯符号密码，请加入数字和字母！");
          return;
        }
        if(iNum==0&&iSym==0) {
          this.$dialogMethod.showMessage("纯字母密码，请加入字符和数字！");
          return;
        }
        if(iLtt==0) {
          this.$dialogMethod.showMessage("数字和符号构成的密码，请加入字母！");
          return;
        }
        if(iSym==0) {
          this.$dialogMethod.showMessage("数字和字母构成的密码，请加入字符！");
          return;
        }
        if(iNum==0) {
          this.$dialogMethod.showMessage("字母和符号构成的密码，请加入数字！");
          return;
        }
      },
      code () {
        this.codelist="";
        var codes=this.$refs.validCode.codeList;
        for(let i=0;i<codes.length;i++) {
          this.codelist=this.codelist+codes[i].code;
        }
      },
      generateCode (id) {
        /*生成二维码*/
        new QRCode(document.getElementById(id),"http://www.runoob.com");
      },
      loginButton () {
        if(!this.userCode&&this.password=="") {
          this.$message({showClose: true,message: '账号或者密码不能为空！！！',type: 'warning'});
          return
        }
        if(this.verificationCode) {

          var params={code: this.seccode,userCode: this.userCode}
          request({url: "/verification/code/check",method: "get",params}).then(res => {
            if(res.code==200) {
              if(res.data=='true') {
                //登录
                var captcha="web:"+1234;
                // var captcha=this.seccode==""? "web:"+1234:"web:"+this.seccode;
                this.$api.userApi.login(
                  this.userCode,
                  hex_md5(this.password),
                  "Web",
                  captcha,
                  this.isStrongPassword,
                  (respon) => {
                    //判断是否有修改过密码 判断是否为强验证
                    if(respon.changePassword==0&&this.isStrongPassword==1) {
                      //if(this.isStrongPassword == 1) {
                      document.getElementsByClassName("loginTitle")[0].innerHTML=
                        "修改密码";
                      document.getElementsByClassName("loginTitle")[1].innerHTML=
                        "首次登录请修改密码，包含数字，字母和字符";
                      this.showChangPW=true;
                      return;
                    }
                    // if(localStorage.getItem("themeName")){ //如果有主题颜色了，就继续沿用
                    //  console.log("主题名称",localStorage.getItem("themeName"));
                    // }else { //如果还没有主题颜色，就默认是科技蓝
                    //    localStorage.setItem("themeName", '科技蓝');
                    // }
                    var skinArr=JSON.parse(localStorage.getItem("skinArr"))

                    if(skinArr) {
                      //查找该用户是否已经在浏览器登录过
                      var filterArr=skinArr.filter(item => item.userId==respon.userId)

                      if(filterArr.length==0) { //未登录过
                        skinArr.push({
                          'userId': respon.userId,
                          'skinName': "科技蓝",
                        })
                        localStorage.setItem("skinArr",JSON.stringify(skinArr));
                        localStorage.setItem("themeName",'科技蓝')

                      } else { //已经登录过
                        localStorage.setItem("themeName",filterArr[0].skinName)
                      }


                    } else { //如果是首次登录，也就是第一次登录系统
                      var userObj=[{
                        'userId': respon.userId,
                        'skinName': "科技蓝",
                      }]
                      localStorage.setItem("skinArr",JSON.stringify(userObj));
                      localStorage.setItem("themeName",'科技蓝')

                    }
                    this.$store.cacheStore.commit('setSkinFlag',!this.skinFlag);
                    //获取用户信息
                    localStorage.setItem("nowWedoSystemUserCode",this.userCode);
                    this.$store.userStore.commit("setNowUserCode",this.userCode);
                    //用户的具体信息
                    localStorage.setItem("userDetailed",JSON.stringify(respon));
                    //获取用户单位信息
                    this.$store.unitStore.commit("getUnitTree");
                    getReadDeviceTree({'appType': "",'appTypeNos': ''}).then(data => {
                      localStorage.setItem('treeList',JSON.stringify(data.data));
                    })


                    //this.$dialogMethod.showMessage("登录成功，正在跳转。。。");
                    var num=this.$store.deviceStore.state.logoNum
                    setTimeout(() => {
                      //获取菜单并且进入主界面
                      this.$store.menuStore.commit("getMenuList");
                      this.$store.deviceStore.commit("getReadDeviceTreeWithTypeNos",36)
                      //this.$store.deviceStore.commit("getReadDeviceTreeWithTypeNos", 237)
                      //获取电表、水表
                      this.$store.deviceStore.commit("getDeviceTreeByappTypeNos",1001);
                      this.$store.deviceStore.commit("getDeviceTreeByappTypeNos",237);
                      this.$store.deviceStore.commit("getLogo",!num);
                      this.$message({message: '登陆成功，正在跳转...',type: 'success'});
                    },1000);
                    sessionStorage.setItem("isLogin",Date.now());
                    //连接新后台

                    this.$wedoWebSocketClient.connect(respon.webSocketUrl,respon.pkid);
                  },
                  (respon) => {
                    this.$dialogMethod.showMessage(respon);
                    //this.errorMsg = respon
                  }
                );
              } else if(res.data=='false') {
                this.$dialogMethod.showMessage("验证码错误");
                this.index++

              } else {
                this.index++
              }
            }

          })
          return false
          // if(this.seccode.toUpperCase()!=this.codelist.toUpperCase()) {
          //   this.$dialogMethod.showMessage("验证码错误");
          //   this.$refs.validCode.refreshCode();
          //   this.code();
          //   return false;
          // }
        }

        //登录
        var captcha="web:"+1234;
        // var captcha=this.seccode==""? "web:"+1234:"web:"+this.seccode;
        this.$api.userApi.login(
          this.userCode,
          hex_md5(this.password),
          "Web",
          captcha,
          this.isStrongPassword,
          (respon) => {
            //判断是否有修改过密码 判断是否为强验证
            if(respon.changePassword==0&&this.isStrongPassword==1) {
              //if(this.isStrongPassword == 1) {
              document.getElementsByClassName("loginTitle")[0].innerHTML=
                "修改密码";
              document.getElementsByClassName("loginTitle")[1].innerHTML=
                "首次登录请修改密码，包含数字，字母和字符";
              this.showChangPW=true;
              return;
            }
            // if(localStorage.getItem("themeName")){ //如果有主题颜色了，就继续沿用
            //  console.log("主题名称",localStorage.getItem("themeName"));
            // }else { //如果还没有主题颜色，就默认是科技蓝
            //    localStorage.setItem("themeName", '科技蓝');
            // }
            var skinArr=JSON.parse(localStorage.getItem("skinArr"))

            if(skinArr) {
              //查找该用户是否已经在浏览器登录过
              var filterArr=skinArr.filter(item => item.userId==respon.userId)

              if(filterArr.length==0) { //未登录过
                skinArr.push({
                  'userId': respon.userId,
                  'skinName': "科技蓝",
                })
                localStorage.setItem("skinArr",JSON.stringify(skinArr));
                localStorage.setItem("themeName",'科技蓝')

              } else { //已经登录过
                localStorage.setItem("themeName",filterArr[0].skinName)
              }


            } else { //如果是首次登录，也就是第一次登录系统
              var userObj=[{
                'userId': respon.userId,
                'skinName': "科技蓝",
              }]
              localStorage.setItem("skinArr",JSON.stringify(userObj));
              localStorage.setItem("themeName",'科技蓝')

            }
            this.$store.cacheStore.commit('setSkinFlag',!this.skinFlag);
            //获取用户信息
            localStorage.setItem("nowWedoSystemUserCode",this.userCode);
            this.$store.userStore.commit("setNowUserCode",this.userCode);
            //用户的具体信息
            localStorage.setItem("userDetailed",JSON.stringify(respon));
            //获取用户单位信息
            this.$store.unitStore.commit("getUnitTree");
            getReadDeviceTree({'appType': "",'appTypeNos': ''}).then(data => {
              localStorage.setItem('treeList',JSON.stringify(data.data));
            })


            //this.$dialogMethod.showMessage("登录成功，正在跳转。。。");
            var num=this.$store.deviceStore.state.logoNum
            setTimeout(() => {
              //获取菜单并且进入主界面
              this.$store.menuStore.commit("getMenuList");
              this.$store.deviceStore.commit("getReadDeviceTreeWithTypeNos",36)
              //this.$store.deviceStore.commit("getReadDeviceTreeWithTypeNos", 237)
              //获取电表、水表
              this.$store.deviceStore.commit("getDeviceTreeByappTypeNos",1001);
              this.$store.deviceStore.commit("getDeviceTreeByappTypeNos",237);
              this.$store.deviceStore.commit("getLogo",!num);
              this.$message({message: '登陆成功，正在跳转...',type: 'success'});
            },1000);
            sessionStorage.setItem("isLogin",Date.now());
            //连接新后台
            this.$wedoWebSocketClient.connect(respon.webSocketUrl,respon.pkid);
          },
          (respon) => {
        
            this.$message.error(`登录失败，${respon}`);
            // this.$dialogMethod.showMessage(respon);
            //this.errorMsg = respon
          }
        );
      },
    },
  };
</script>
<style>
  .inputed input {
    background: none;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .loginText input {
    background: none;
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
  }
</style>
<style scoped>
  .content {
    background-color: rgba(0, 0, 0, 0.25);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .inputed {
    background: none;
    border: none;
    box-shadow: none;
  }



  .loginContent input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    height: 27px !important;
    line-height: 27px !important;
    border-radius: 0 4px 4px 0;
  }

  .unitTitle {
    margin-top: 5%;
    margin-left: 5%;
    margin-bottom: 3%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    box-sizing: border-box;
    margin-right: 5%;
    z-index: 1;
  }

  .errorMsg {
    display: flex;
    align-items: center;
    width: 89%;
    margin-left: 5px;
    margin-top: 15px;
  }

  .loginText {
    margin-top: 20px;
    border: 1px solid #d6d6d6;
    padding: 2%;
    width: 85%;
    border-radius: 2px;
    height: 48px;
    box-sizing: border-box;
  }

  .loginText img {
    width: 20px;
    height: 20px;
  }

  .loginText input {
    outline: none;
    width: calc(100% - 25px);
    height: 27px !important;
    line-height: 27px !important;
    font-size: 16px;
    margin-left: 5px;
  }

  .loginText input {
    outline: none;
    background: transparent;
    border: none;
    outline: medium;
    width: 100%;
    height: 50px;
    outline: none;
  }






  .loginButton {
    cursor: pointer;
    box-sizing: border-box;
    margin-top: 40px;
    font-size: 20px;
    width: 85%;
    height: 48px;
    line-height: 48px;
    border-radius: 2px;
    box-shadow: 0 6px 12px 0 #358ad254;
    background: #368ED9;
    margin-bottom: 20px;
  }

  .loginTitle {
    width: 89%;
    font-size: 40px;
    margin-bottom: 0;
    text-align: center;
    margin-top: 25px;
    color: #368ED9;
  }

  .loginTitle_txt {
    font-size: 18px;
    line-height: 20px;
    color: #999;
    font-size: 12px;
    margin-top: 25px;
    margin-bottom: 20px;
  }

  .cnTitle {
    letter-spacing: 3px;
    margin-bottom: 15px;
  }

  .loginBody {
    min-width: 1366px;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex !important;
    justify-content: space-between !important;
    opacity: 0;
  }

  .loginContent {
    width: 350px;
    /* background-color: rgba(255, 255, 255, 0.5); */
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* position: absolute;
		 top: 12%; 
		 right: 20px;*/
    padding: 30px;
    border-radius: 6px;
    z-index: 99;
    /* min-height: 357px; */
    position: absolute;
    top: calc(0.5 * (100% - 410px));
    left: calc(0.5 * (100% - 395px));
  }

  .videoBg {
    background: white;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    overflow: hidden;
  }

  .videoPlayer {
    width: 100%;
  }

  .qrcode {
    display: inline-flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    margin-right: 40px;
  }

  .qrcode>img {
    width: 100px;
    height: 100px;
  }

  .qrcode>p {
    color: white;
    text-align: center;
  }

  .information {
    position: absolute;
    z-index: 1;
    bottom: 20px;
    width: 100%;
  }

  .information>a {
    display: block;
    color: #bbb;
    font-size: 14px;
    text-align: center;
    text-decoration: none;
  }

  .logo {}
</style>